<template>
  <section class="section">
    <LazyBg :src="bgSrc" />
    <div class="section-dim" aria-hidden="true" />
    <div class="container">
      <h2 class="section-title">荣誉资质</h2>
      <p class="section-lead">
        凭借自主创新、合规运营与场景落地能力，收获多项权威认证、资质认定与行业荣誉
      </p>

      <div class="features-grid features-grid--quad">
        <div v-for="b in blocks" :key="b.title" class="feature-card">
          <div class="feature-tag" />
          <h3>{{ b.title }}</h3>
          <ul class="honors-list">
            <li v-for="item in b.items" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>

      <div class="metrics-strip">
        <div v-for="m in metrics" :key="m.label" class="metric-item">
          <div class="metric-value">
            {{ m.value }}<span class="metric-dw">{{ m.unit }}</span>
          </div>
          <div class="metric-label">{{ m.label }}</div>
        </div>
      </div>

      <div class="honors-media">
        <div class="feature-card honors-media-card">
          <h3>行业荣誉奖项</h3>
          <ul class="honors-list">
            <li v-for="a in awards" :key="a">{{ a }}</li>
          </ul>
        </div>
        <div class="honors-media-imgs">
          <img src="@/assets/zlzs.jpg" alt="知识产权与资质证书" loading="lazy" />
          <img src="@/assets/ryzs.jpg" alt="行业荣誉奖项" loading="lazy" />
        </div>
      </div>

      <p class="honors-note">
        上市公司禾盛新材（002290.SZ）核心子公司：依托上市集团资源，技术研发与产业布局获资本加持。
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import LazyBg from '@/components/LazyBg.vue';
import bgSrc from '@/assets/about_bg_honors.png';

const blocks = [
  {
    title: '权威体系认证',
    items: [
      'ISO9001 质量管理体系认证，覆盖研发、交付与售后全流程',
      '3C 强制性产品认证，核心 AI 硬件产品符合国家强制安全标准',
      '增值电信业务经营许可证，合规开展互联网技术服务'
    ]
  },
  {
    title: '官方资质认定',
    items: [
      '国家科技型中小企业，研发创新能力获政府认可',
      '上海市科技型中小企业技术创新资金立项',
      '享受研发费用加计扣除等政策支持'
    ]
  },
  {
    title: '知识产权成果',
    items: [
      '发明专利 5 项',
      '实用新型专利 1 项、外观专利 1 项',
      '软件著作权 23 项、注册商标 10 个'
    ]
  },
  {
    title: '生态与合作',
    items: [
      '上市公司禾盛新材（002290.SZ）核心子公司',
      '技术研发与产业布局获资本加持',
      '持续拓展产学研与产业生态合作'
    ]
  }
];

const metrics = [
  { value: '5', unit: '项', label: '发明专利' },
  { value: '23', unit: '项', label: '软件著作权' },
  { value: '10', unit: '个', label: '注册商标' },
  { value: '30+', unit: '', label: '自主知识产权' }
];

const awards = [
  '上海市优秀信创解决方案提供商',
  '2025 年度科创新锐企业奖',
  '乐创东明创新创业大赛数智文娱赛道银奖',
  '2025 年 AI 元宇宙 1000 优秀产品与示范案例',
  '上海市元宇宙新赛道创新产品和解决方案',
  '2025-2026“乐创东明”创新创业大赛数智文娱赛道银奖'
];
</script>

<style scoped lang="scss">
.section-dim {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.45));
  pointer-events: none;
}

.container {
  position: relative;
  z-index: 2;
}

.feature-tag {
  width: 36px;
  height: 4px;
  background: #0095ff;
  margin-bottom: 24px;
}

.honors-list {
  margin: 0;
  padding-left: 1.2em;
  list-style: disc;
  font-size: 14px;
  line-height: 1.7;
  color: #fff;
  opacity: 0.7;

  li + li {
    margin-top: 8px;
  }
}

.metrics-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 56px;
  text-align: center;
}

.metric-item {
  flex: 1;
  min-width: 0;
}

.metric-value {
  font-family: "Fira Sans", "Noto Sans SC", sans-serif;
  font-size: clamp(36px, 4vw, 56px);
  font-style: italic;
  font-weight: 900;
  margin-bottom: 12px;
  color: #fff;
}

.metric-dw {
  font-size: 18px;
  font-style: normal;
  margin-left: 2px;
}

.metric-label {
  font-size: 14px;
  line-height: 24px;
  color: #a4abbc;
}

.honors-media {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: 24px;
  margin-top: 56px;
  align-items: stretch;
}

.honors-media-card {
  height: 100%;
}

.honors-media-imgs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  img {
    width: 100%;
    height: 100%;
    min-height: 180px;
    object-fit: cover;
    border-radius: 8px;
    border: 1px solid rgba(239, 239, 239, 0.2);
  }
}

.honors-note {
  margin: 40px auto 0;
  max-width: 800px;
  text-align: center;
  font-size: 15px;
  line-height: 1.7;
  color: #fff;
  opacity: 0.75;
}

@media (max-width: 900px) {
  .honors-media {
    grid-template-columns: 1fr;
  }

  .metrics-strip {
    flex-wrap: wrap;
  }

  .metric-item {
    flex: 1 1 40%;
  }
}

@media (max-width: 640px) {
  .honors-media-imgs {
    grid-template-columns: 1fr;
  }

  .metric-item {
    flex: 1 1 100%;
  }
}
</style>
